import { api } from './api';
import type { PaginatedResponse } from './secretary';

// ─── StorageFile ────────────────────────────────────────────────────────────
// Casa com StorageFileSerializer (apps/storage/serializers.py). Usado pelo
// picker "Biblioteca da escola" no anexo de arquivos do chat WhatsApp.

export interface StorageFile {
  id: string;
  school: string;
  school_name: string;
  name: string;
  size: number;
  size_formatted: string;
  mime_type: string;
  extension: string;
  is_folder: boolean;
  parent_folder: string | null;
  full_path: string;
  breadcrumb: { id: string; name: string }[];
  children_count: number | null;
  description: string;
  tags: string;
  is_public: boolean;
  created_by: number | null;
  created_by_name: string | null;
  created_at: string;
  updated_at: string;
  download_url: string | null;
}

export interface StorageListParams {
  parent_folder?: string | null;
  search?: string;
  is_folder?: boolean;
}

// ─── Service ────────────────────────────────────────────────────────────────

export const storageService = {
  list: (params?: StorageListParams) => {
    const query: Record<string, string> = {};
    if (params?.parent_folder !== undefined) {
      query.parent_folder = params.parent_folder === null ? 'null' : params.parent_folder;
    }
    if (params?.search) query.search = params.search;
    if (params?.is_folder !== undefined) query.is_folder = String(params.is_folder);

    return api
      .get<PaginatedResponse<StorageFile> | StorageFile[]>('/storage/', { params: query })
      .then((res) => (Array.isArray(res) ? res : res.results ?? []));
  },

  /**
   * `chatGroupId`: anexo do chat interno — o backend salva o arquivo na escola
   * da conversa (não na de quem envia). Necessário no canal de suporte, onde
   * a equipe Eleve é de outra escola; sem isso o envio da mensagem dá 400.
   */
  upload: (file: File, parentFolderId?: string, options?: { chatGroupId?: string }) => {
    const formData = new FormData();
    formData.append('file', file);
    if (parentFolderId) formData.append('parent_folder_id', parentFolderId);
    if (options?.chatGroupId) formData.append('chat_group_id', options.chatGroupId);
    return api.post<StorageFile>('/storage/upload/', formData);
  },
};
